import React, {useEffect, useState} from 'react';
import {IWorkspaceItem} from "../../models/Workspace";
import {useGetWorkspaceQuery} from "../../store/Api";
import {usePutWorkspaceItemDetailsMutation} from "../../store/endpoints/WorkspaceItemsEndpoints";
import {Checkbox} from "@fluentui/react";

interface ITaxableSelectionProps {
    item: IWorkspaceItem;
    isExample?: boolean;
}

const TaxableSelection: React.FC<ITaxableSelectionProps> = (props) => {
    const [detailsChange] = usePutWorkspaceItemDetailsMutation();
    const workspace = useGetWorkspaceQuery(props.item.workspace, {
        skip: (props.isExample || !props.item.workspace || props.item.workspace.trim().length === 0)
    });
    const [defaultChecked, setDefaultChecked] = useState<boolean>();
    const [checked, setChecked] = useState<boolean>();

    useEffect(() => {
        setChecked(props.item.details?.isTaxable);
    }, [props.item.details?.isTaxable])
    
    const getLabel = () => {
        if(checked == null && defaultChecked != null) {
            return '(From Default)';
        }
        return '';
    }
    
    useEffect(() => {
        setDefaultChecked(workspace?.data?.defaultTaxable);
    }, [workspace?.data?.defaultTaxable])
    return (<><Checkbox
        label={getLabel()}
        checked={(checked ?? defaultChecked) === true}
        onChange={(e,d) => {
        if (d != undefined && !props.isExample) {
            detailsChange({
                workspace: props.item.workspace,
                product: props.item.id,
                details: {
                    ...props.item.details,
                    isTaxable: d
                }
            })
        }
    }}
    /></>)
}

export default TaxableSelection;